import React, { useState, useRef, useEffect } from 'react'
import '../../../css/programList.css'
import PersonDetailModal from '../People/PersonDetailModal'
import api from '../../../services/api';

const ProgramCard = ({ program, schedules, episodes, onSchedule, onDelete, onViewDetails }) => {
  const [expanded, setExpanded] = useState(false)
  const [detailPerson, setDetailPerson] = useState(null)
  const contentRef = useRef(null)

  const handlePersonClick = async (person) => {
    try {
      // Fetch della persona completa con qualifications
      const response = await api.get(`/people/${person.id}`)
      setDetailPerson(response.data)
    } catch (error) {
      console.error('Error loading person details:', error)
      // Fallback: usa i dati disponibili
      setDetailPerson(person)
    }
  }

  useEffect(() => {
    if (!contentRef.current) return
    if (expanded) {
      contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px'
      contentRef.current.style.padding = '20px'
    } else {
      contentRef.current.style.maxHeight = '0px'
      contentRef.current.style.padding = '0 20px'
    }
  }, [expanded])

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return ''
    const date = new Date(dateTimeString)
    return date.toLocaleDateString()
  }

  const displayScheduleDate = (schedule) => {
    if (schedule.isRecurring) {
      return `Ricorrente: ${schedule.dayOfWeek}`
    }
    return formatDateTime(schedule.date)
  }

  return (
    <div className="programlist-card">
      <div
        className="programlist-card-cover"
        onClick={() => setExpanded(prev => !prev)}
      >
        <div
          className="programlist-card-cover-blur"
          style={{ backgroundImage: `url(${program.imageUrl || 'https://via.placeholder.com/200'})` }}
        />
        <div
          className="programlist-card-cover-main"
          style={{ backgroundImage: `url(${program.imageUrl || 'https://via.placeholder.com/200'})` }}
        />
        <div className="programlist-card-cover-overlay">
          <h3 className="programlist-card-title">{program.title}</h3>
        </div>
      </div>

      <div className="programlist-card-content" ref={contentRef}>
        {expanded && (
          <>
            <p className="program-description">{program.description}</p>

            {program.protagonists?.length > 0 && (
              <div className="program-section">
                <h4>Protagonisti:</h4>
                <div className="protagonists-container">
                  {program.protagonists.map(person => (
                    <div
                      key={person.id}
                      className="protagonist-chip"
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePersonClick(person);
                      }}
                      style={{ cursor: 'pointer' }}
                      title="Clicca per visualizzare i dettagli"
                    >
                      <img
                        src={person.imageUrl || person.image_url || 'https://via.placeholder.com/30'}
                        alt={`${person.nome} ${person.cognome}`}
                      />
                      <span>{person.nome} {person.cognome}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {program.expectedGuests?.length > 0 && (
              <div className="program-section">
                <h4>Ospiti Attesi:</h4>
                <div className="expected-guests-container">
                  {program.expectedGuests.map(person => (
                    <div
                      key={person.id}
                      className="expected-guest-chip"
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePersonClick(person);
                      }}
                      style={{ cursor: 'pointer' }}
                      title="Clicca per visualizzare i dettagli"
                    >
                      <img
                        src={person.imageUrl || person.image_url || 'https://via.placeholder.com/30'}
                        alt={`${person.nome} ${person.cognome}`}
                      />
                      <span>{person.nome} {person.cognome}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {program.topics?.length > 0 && (
              <div className="program-section">
                <h4>Topics:</h4>
                <div className="topics-container">
                  {program.topics.map(topic => (
                    <span key={topic.id} className="topic-chip">{topic.name}</span>
                  ))}
                </div>
              </div>
            )}

            <div className="program-section">
              <h4>Orari Ricorrenti:</h4>
              {schedules
                .filter(schedule => Number(schedule.programId) === Number(program.id))
                .filter(schedule => schedule.isRecurring)
                .map(schedule => (
                  <div key={schedule.id} className="programlist-schedule-item">
                    <span className="schedule-date">{displayScheduleDate(schedule)}</span>
                    <span className="schedule-time">
                      {(schedule.startTime || '').slice(0, 5)} - {(schedule.endTime || '').slice(0, 5)}
                    </span>
                  </div>
                ))}
            </div>

            <div className="program-actions">
              <button
                className="action-btn schedule-btn"
                onClick={() => onSchedule(program.id)}
              >
                SCHEDULES
              </button>
              <button
                className="action-btn delete-btn"
                onClick={() => onDelete(program.id)}
              >
                ELIMINA
              </button>
              <button
                className="action-btn view-btn"
                onClick={() => onViewDetails(program.id)}
              >
                DETTAGLI
              </button>
            </div>
          </>
        )}
      </div>

      {detailPerson && (
        <PersonDetailModal
          person={detailPerson}
          onClose={() => setDetailPerson(null)}
        />
      )}
    </div>
  )
}

export default ProgramCard
